var icon = require('vue-svgicon')
icon.register({
  'ks-icon-upload': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M49.71 86.29V56.71H30l34.5-34.5L99 56.71H79.29v29.58H49.71M30 106v-9.86h69V106z"/>'
  }
})
